import { urlPattern } from '../containers/dashboard/companies/company-view';

export function dashed(str) {
	if (typeof str !== 'string') return null;
	return str.toLowerCase().replace(/\s/g, '-');
}

export function formatDashedNumber(num) {
	if (!num) return;
	return `${num}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function titlize(str) {
	if (str.length < 1) return str;
	let charArr = str.toLowerCase().split('');
	return charArr[0].toUpperCase() + charArr.slice(1).join('');
}

export function camelCaseToWord(str) {
	return str
		.replace(/([A-Z])/g, ' $1')
		.split(' ')
		.map(n => titlize(n.toLowerCase()))
		.join(' ');
}

export function snakeCaseToWord(str) {
	return str
		.replace(/_/g, ' ')
		.split(' ')
		.map(n => titlize(n.toLowerCase()))
		.join(' ');
}

export function locationToAddress(location) {
	if (location.constructor.name != 'Object') return location;
	let area = location.area;
	if (urlPattern.test(area)) area = '';
	const city = location.city;
	const country = location.country;
	return [area, city, country].filter(i => !!i).join(', ');
}

// export function convertRange(range, suffix = null) {
// 	let patterns = [
// 		{ pattern: /^\d+$/g, message: () => `${arguments[0]}` },
// 		{ pattern: /^\d-+\d+$/g, message: () => `${arguments[0]} to ${arguments[1]}` },
// 		{ pattern: /^(\++\d+|\d+\++)$/g, message: () => `${arguments[0]} at least` },
// 		{ pattern: /^(-+\d+|\d+-+)$/g, message: () => `${arguments[0]} at most` }
// 	];
// 	range = range.trim();
// 	for (let p of patterns) {
// 		if (range.match(p.pattern)) {
// 			let nums = range.match(/\d+/g);
// 			// console.log(range.match(/\d+/g), p.message(...nums), p.message());
// 			return `${p.message(...nums)}${suffix ? ' ' + suffix : ''}`;
// 		}
// 	}
// 	return null;
// }

export function getRandomHexColor() {
	const hex = '0123456789abcdef';
	let color = '#';

	for (let i = 0; i < 6; i++) {
		let digit = hex[Math.floor(Math.random() * 16)];
		color += digit;
	}
	return color;
}

export function getInitialsFromName(firstName, lastName) {
	return `${firstName[0]}${lastName[0]}`;
}
